"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMERA_TYPE = void 0;
// #endregion Interfaces (1)
// #region Enums (1)
var CAMERA_TYPE;
(function (CAMERA_TYPE) {
    CAMERA_TYPE["PERSPECTIVE"] = "perspective";
    CAMERA_TYPE["ORTHOGRAPHIC"] = "orthographic";
})(CAMERA_TYPE = exports.CAMERA_TYPE || (exports.CAMERA_TYPE = {}));
// #endregion Enums (1)
//# sourceMappingURL=ICameraEngine.js.map